// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


// import "jquery"
// import "select2"
// import 'bootstrap'
// import '../stylesheets/application.scss'
// import "popper.js"
// import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
// import * as ActiveStorage from "@rails/activestorage"
// import "channels"

// Rails.start()
// Turbolinks.start()
// ActiveStorage.start()

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require('./libs/jquery-3.5.1.min.js');
// require("jquery")
// require("jquery-ui") // これがないと main がエラーになる

require('./libs/bootstrap.min.js');
import '@fortawesome/fontawesome-free/js/all'
require('../ikou/admin.js')


require('ikou/common/booklet')
require('ikou/common/jquery.sortable.min')
require('ikou/common/list.min')
require('ikou/common/viewer')
require('ikou/common/viewer_demo')
require('ikou/common/lightbox-2.6.min')
require('ikou/common/select2.min')
require('ikou/common/viewer2')
require('ikou/common/viewer_staging')
//= require  '../ikou/turnjs4/*'
// require('ikou/local/lg_urgent_topic')
require('ikou/local/magazine_issues')

//= require '../ikou/comon/*'
//= require  '../ikou/turnjs4/*'
//= require '../ikou/admin/*'
//= require  '../ikou/local/*'


